<mat-card class="mat-elevation-z">
  <div class="settings-title">
    {{ TranslationKeys.MenuSettings | translate }}
  </div>
  <nimbus-material-tabs-wrapper class="settings-tab-wrapper">
    @for (tabItem of tabItems; track tabItem) {
      <nimbus-material-tab [model]="tabItem" (tabSelect)="navigateTo(tabItem?.id)"> </nimbus-material-tab>
    }
  </nimbus-material-tabs-wrapper>
  <div class="tab-form-body" [formGroup]="form">
    @if (isTabActive(settingsTabGeneral)) {
      <app-settings-general-tab [formGroupName]="settingsTabGeneral"></app-settings-general-tab>
    }
    @if (isTabActive(settingsTabNotifications)) {
      <app-settings-notifications-tab [formGroupName]="settingsTabNotifications"></app-settings-notifications-tab>
    }
    @if (isTabActive(settingsTabAppearance)) {
      <app-settings-appearance-tab [formGroupName]="settingsTabAppearance"></app-settings-appearance-tab>
    }
  </div>
  <div nimbusMaterialButtonsRow class="settings-buttons">
    <div>
      <button nimbusSecondaryButton (click)="cancel()" class="settings-button" [routerLink]="['/home']">
        {{ TranslationKeys.GeneralCancel | translate }}
      </button>
    </div>
    <div>
      <button nimbusPrimaryButton [disabled]="!form?.valid" (click)="save()" class="settings-button">
        {{ TranslationKeys.GeneralSave | translate }}
      </button>
    </div>
  </div>
</mat-card>
